import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>Sem Permissão</h1>
            <br />
            <p> Não tem acesso à página pedida.</p>
            <div className="flexGrow">
                <button onClick={goBack}>Voltar</button>

            </div>
        </section>
    )
}

export default Unauthorized;